import * as React from "react";
import Iconify from "../iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import SendOtp from "./sendOtp";
import VerifyOtp from "./verifyOtp";
import CustomIconButton from "@/src/lib/ui/iconButton";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

export default function LoginPopUp({
    setOpen,
    open,
    isAddPatientWithAnotherNumber = false,
    onClose,
    title,
    isTransferPatient = null,
    uId,
    refetch,
    setIsStep,
}) {
    const [mobileNumber, setMobileNumber] = React.useState("");
    const [otp, setOtp] = React.useState("");
    const isMobile = useBreakpoint("sm");

    const handleClose = () => {
        setOpen(false);
        setMobileNumber("");
        setOtp("");
        onClose();
    };

    return (
        <>
            <ConfirmDialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullScreen={isMobile}
                content={
                    <div className="md:p-4 p-2 relative">
                        <CustomIconButton
                            className="absolute -right-4 -top-4"
                            onClick={handleClose}
                        >
                            <Iconify
                                icon={IconCode.close}
                                color="black"
                                width="32px"
                                className="text-primary"
                            />
                        </CustomIconButton>

                        {!!otp ? (
                            <VerifyOtp
                                mobileNumber={mobileNumber}
                                setOtp={setOtp}
                                otp={otp}
                                setOpen={setOpen}
                                isTransferPatient={isTransferPatient}
                                isAddPatientWithAnotherNumber={
                                    isAddPatientWithAnotherNumber
                                }
                                uId={uId}
                                refetch={refetch}
                                handleClose={handleClose}
                            />
                        ) : (
                            <SendOtp
                                setOtp={setOtp}
                                setMobileNumber={setMobileNumber}
                                mobileNumber={mobileNumber}
                                otp={otp}
                                isAddPatientWithAnotherNumber={
                                    isAddPatientWithAnotherNumber
                                }
                                title={title}
                            />
                        )}
                    </div>
                }
            />
        </>
    );
}
